module.exports = __webpack_public_path__ + "img/logo.897b81b2.png";